import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initTheme } from './theme/darkMode.js';
import './styles.css';
import App from './App.jsx';

initTheme(); // antes do primeiro paint — evita flash de tema errado

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App/>
  </StrictMode>
);
